(function (root) {
  'use strict';
  function valid(q) {
    if (!Array.isArray(q) || q.length !== 4) return false;
    var area = 0;
    for (var i = 0; i < 4; i++) {
      var a = q[i], b = q[(i + 1) % 4], c = q[(i + 2) % 4];
      if (!a || !Number.isFinite(a.x) || !Number.isFinite(a.y) || a.x < 0 || a.x > 1 || a.y < 0 || a.y > 1) return false;
      if ((b.x - a.x) * (c.y - b.y) - (b.y - a.y) * (c.x - b.x) < .002) return false;
      area += a.x * b.y - b.x * a.y;
    }
    return area > .04;
  }
  function matrix(q) {
    var a = q[0], b = q[1], c = q[2], d = q[3];
    var dx1 = b.x - c.x, dx2 = d.x - c.x, dx3 = a.x - b.x + c.x - d.x;
    var dy1 = b.y - c.y, dy2 = d.y - c.y, dy3 = a.y - b.y + c.y - d.y;
    var den = dx1 * dy2 - dx2 * dy1;
    if (Math.abs(den) < 1e-12) throw new Error('plane');
    var g = (dx3 * dy2 - dx2 * dy3) / den, h = (dx1 * dy3 - dx3 * dy1) / den;
    return [b.x - a.x + g * b.x, d.x - a.x + h * d.x, a.x,
      b.y - a.y + g * b.y, d.y - a.y + h * d.y, a.y, g, h, 1];
  }
  function project(m, p) {
    var z = m[6] * p.x + m[7] * p.y + m[8];
    if (Math.abs(z) < 1e-10) throw new Error('horizon');
    return { x: (m[0] * p.x + m[1] * p.y + m[2]) / z, y: (m[3] * p.x + m[4] * p.y + m[5]) / z };
  }
  function inverse(m) {
    var a = m[0], b = m[1], c = m[2], d = m[3], e = m[4], f = m[5], g = m[6], h = m[7], i = m[8];
    var n = [e*i-f*h, c*h-b*i, b*f-c*e, f*g-d*i, a*i-c*g, c*d-a*f, d*h-e*g, b*g-a*h, a*e-b*d];
    var det = a*n[0]+b*n[3]+c*n[6];
    if (Math.abs(det) < 1e-12) throw new Error('plane');
    return n.map(function (v) { return v / det; });
  }
  function corners(plan, centre, w, h) {
    var rw = w / plan.largeur_cm, rh = h / plan.hauteur_cm;
    var x = centre.x, y = centre.y;
    if (![rw,rh,x,y].every(Number.isFinite) || rw <= 0 || rh <= 0) return null;
    var m = matrix(plan.coins);
    var q = [{x:x-rw/2,y:y-rh/2},{x:x+rw/2,y:y-rh/2},{x:x+rw/2,y:y+rh/2},{x:x-rw/2,y:y+rh/2}];
    if (q.some(function (p) { return m[6]*p.x + m[7]*p.y + m[8] <= 1e-8; })) return null;
    return q.map(function (p) { return project(m, p); });
  }
  function measure(plan, a, b) {
    var inv = inverse(matrix(plan.coins)), p = project(inv, a), q = project(inv, b);
    return Math.hypot((p.x-q.x)*plan.largeur_cm, (p.y-q.y)*plan.hauteur_cm);
  }
  function css(q, width, height, sourceW, sourceH) {
    var m = matrix(q.map(function (p) { return { x: p.x*width, y: p.y*height }; }));
    return 'matrix3d(' + [m[0]/sourceW,m[3]/sourceW,0,m[6]/sourceW,
      m[1]/sourceH,m[4]/sourceH,0,m[7]/sourceH,0,0,1,0,m[2],m[5],0,1].join(',') + ')';
  }
  var api = { valid: valid, matrix: matrix, project: project, inverse: inverse, corners: corners, measure: measure, css: css };
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.AfRoomGeometry = api;
})(typeof window === 'object' ? window : globalThis);
